<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div class="zoom">
    <section class="subscribe-service">
      <div class="introduce">
        <div class="introduce-box">
          <div class="open">
            <p class="title">{{ service.title }}</p>
            <p class="content">{{ service.content }}</p>
            <a-button @click="openService" class="button-primary btn">开通</a-button>
            <div class="button-border-primary" @click="toJump">进入应用</div>
          </div>
        </div>
      </div>
      <div class="cards">
        <service-card v-for="card in cards" :key="card.title" :detail="card" />
      </div>
      <div class="plan">
        <!-- <a-tabs v-model:activeKey="tabKey" centered>
        <a-tab-pane v-for="tab in tabs" :key="tab.key" :tab="tab.name">
          <service-summary v-if="tab.key === '1'" />
          <api-list v-if="tab.key === '2'" />
        </a-tab-pane>
      </a-tabs> -->
        <div class="service-title">应用概况</div>
        <summary-machine-room />
      </div>
      <t-footer />
      <drawer-machine-room :service="service" ref="drawer" />
    </section>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { Button, Tabs } from "ant-design-vue";
import Card from "@/views/subscribe-service/components/card.vue";
import Summary from "@/views/subscribe-service/components/summary-machine-room.vue";
import ApiList from "@/views/subscribe-service/components/api-list.vue";
import { TFooter } from "@/components/layout";
import Drawer from "@/views/subscribe-service/components/drawer-machine-room.vue";
import { useRoute } from "vue-router";
const TabPane = Tabs.TabPane;

export default {
  components: {
    [Button.name]: Button,
    [Card.name]: Card,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Summary.name]: Summary,
    [ApiList.name]: ApiList,
    [Drawer.name]: Drawer,
    [TFooter.name]: TFooter
  },
  setup() {
    const cards = ref([
      {
        title: "应用类型",
        content: "智慧节能应用",
        src: require("@/assets/img/service-type.png")
      },
      {
        title: "应用提供商",
        content: "特斯联研发中心",
        src: require("@/assets/img/service-author.png")
      },
      {
        title: "更新时间",
        content: "2022/02/25",
        src: require("@/assets/img/service-update.png")
      },
      {
        title: "版本",
        content: "V 1.0.0",
        src: require("@/assets/img/service-version.png")
      }
    ]);
    const tabs = [
      {
        name: "服务概况",
        key: "1"
      },
      {
        name: "API列表",
        key: "2"
      }
    ];
    const tabKey = ref("1");
    const drawer = ref(null);

    const openService = () => {
      drawer.value.showModal();
    };

    const service = reactive({
      title: "高效机房",
      content:
        "为赋能城市建筑运营者，特斯联研发的高效机房数据可视化平台可以协同特斯联自有的元启BA系统或者存量BA系统，抽取关键指标数据，协助运营人员脱离机房限制，在云端自主查看机房运行的关键指标和动态监测机房运行状态。"
    });
    const showContent = () => {
      if (route.query.id == 2) {
        service.title = "卡证识别";
        service.content =
          "卡证识别的内容，舒适室内环境控制评估指标模型可以评估建筑物内空调采暖系统，新风系统，空气净化系统，照明系统和遮阳系统的控制能力和用能状况进行评估。在一个客观的量";
      } else if (route.query.id == 3) {
        service.title = "语音识别服务";
        service.content =
          "语音识别内容，舒适室内环境控制评估指标模型可以评估建筑物内空调采暖系统，新风系统，空气净化系统，照明系统和遮阳系统的控制能力和用能状况进行评估。在一个客观的量";
      }
    };
    const route = useRoute();
    const toJump = () => {
      window.open("https://archi-brain.tslsmart.com");
    };
    onMounted(() => {
      showContent();
    });
    return {
      cards,
      tabs,
      tabKey,
      drawer,
      openService,
      service,
      toJump
    };
  }
};
</script>

<style lang="less" scoped>
.service-title {
  margin-bottom: 50px;
  color: #1d2129;
  font-weight: 600;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
}
.button-border-primary {
  width: 120px;
  height: 40px;
  margin-left: 8px;
  line-height: 38px;
  border-radius: 2px;
}
.subscribe-service {
  .introduce {
    height: 360px;
    padding-top: 54px;
    background: url("../../assets/img/service-abas.jpg") no-repeat center center;
    .introduce-box {
      width: 1392px;
      margin: 0 auto;
    }
    .open {
      width: 600px;
      height: 252px;
      padding: 30px 76px 30px 24px;
      text-align: left;
      background: rgba(255, 255, 255, 0.6);
      backdrop-filter: blur(4px);
      .title {
        color: #1d2129;
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;
      }
      .content {
        display: -webkit-box;
        margin-top: 16px;
        overflow: hidden;
        color: #4e5969;
        font-size: 14px;
        line-height: 22px;
        text-overflow: ellipsis;

        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
      }
      .btn {
        width: 120px;
        height: 40px;
        margin-top: 16px;
      }
      :deep(.ant-btn-primary) {
        background: #5d65fb;
        border-color: #5d65fb;
        box-shadow: none;
      }
    }
  }
  .cards {
    display: flex;
    width: 1392px;
    // margin: 24px 15vw;
    margin: 24px auto;
    & > div {
      flex: 1;
    }
    :not(:last-child) {
      margin-right: 16px;
    }
  }
  .plan {
    margin-top: 24px;
    // padding: 0 15vw 52px 15vw;
    padding-top: 32px;
    background-color: #fff;
    .service-summary {
      width: 1392px;
      margin: auto;
    }
  }
}
</style>
